document.addEventListener('turbolinks:load', function () {

  const DOMAIN = $('#pl_domain').val();

  $('.chat_bot_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.chat_bot_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.chat_bot_slidedown_btn').fadeIn(0));
  });

  $('.chat_bot_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.chat_bot_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.chat_bot_slideup_btn').fadeIn(0));
  });

  // ------------------------------------------------------------------------------------------------
  // チャットボットレポート
  // ------------------------------------------------------------------------------------------------
  function chat_bot_update_url() {
    const chat_id = $('#chat_selects option:selected').val();
    const chat_option_id = $('#chat_option_selects option:selected').val();
    const gf = $('#chat_graph_pattern_select_input').val();
    const device = $('.chat_device_select').data('device');
    const start_day = $('#chat_report_start_day').val();
    const end_day = $('#chat_report_end_day').val();

    let url = new URL(window.location.href);
    let params = url.searchParams;

    if (chat_id !== 'none' && chat_id !== null && chat_id !== undefined) {
      params.set('chat_id', chat_id);
    } else {
      params.delete('chat_id');
    }

    if (chat_option_id !== 'none' && chat_option_id !== null && chat_option_id !== undefined) {
      params.set('chat_option_id', chat_option_id);
    } else {
      params.delete('chat_option_id');
    }

    if (gf) {
      params.set('gf', gf);
    } else {
      params.delete('gf');
    }

    if (device == "0" || device == "1" || device == "2") {
      params.set('device', device);
    } else {
      params.delete('device');
    }

    if (gf === '12') {
      params.delete('start_day');
      params.delete('end_day');
    } else {  // このelseブロックを追加
      if (start_day) {
        params.set('start_day', start_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }

      if (end_day) {
        params.set('end_day', end_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }
    }

    url.search = params.toString();
    location.href = url.toString();
  }

  // #################################################################
  // チャットボット,チャットボットメニューの選択
  // #################################################################
  $('#chat_selects, #chat_option_selects').on('change', function () {
    chat_bot_update_url();
  });

  // #################################################################
  // 日毎、月毎のグラフ切り替え
  // #################################################################
  $('.chat_graph_pattern_select_day, .chat_graph_pattern_select_month').on('click', function () {
    const gf_value = $(this).data('gf');
    $('#chat_graph_pattern_select_input').val(gf_value);
    chat_bot_update_url();
  });

  // #################################################################
  // デバイスごとのグラフ切り替え
  // #################################################################
  $('.chat_device_select_all, .chat_device_select_pc, .chat_device_select_phone').on('click', function () {
    const device = $(this).data('device');
    $('.chat_device_select').data("device", device);
    chat_bot_update_url();
  });

  // #################################################################
  // 範囲選択によるグラフ切り替え
  // #################################################################
  $('#chat_report_start_day, #chat_report_end_day').on('change', function () {
    chat_bot_update_url();
  });

  // #################################################################
  // 表の年月切り替え
  // #################################################################
  $('#ua_chat_month_selects').on('change', function () {
    let chat_id = $('#chat_selects option:selected').val();
    let month = $('#ua_chat_month_selects option:selected').val();
    let url = new URL(window.location.href);

    if (month != '') {
      if (url.searchParams.has('m')) {
        // 値が "0"か"1" なら "2" に更新する
        let new_value = month;
        // パラメーターの値を更新する
        url.searchParams.set('m', new_value);
      } else {
        // パラメーターにdeviceがない場合
        // 新しいパラメーターを追加する
        url.searchParams.append('m', month);
      }

      // 更新されたURLにリダイレクトする
      location.href = url.toString();
    } else {
      // monthが空文字の時は指定したURLにリダイレクトする
      // location.href = 'ugc_analysis';
    }
  });

  // #################################################################
  // チャットボットのログデータのみの削除
  // #################################################################
  $('.delete_chat_bot_log_data').on('click', function () {
    if (!confirm('本当に削除を実行しますか？')) {
      return;
    }
    const chat_id = $('#chat_selects option:selected').val();

    $.ajax({
      url: '/c/delete_chat_log',
      type: 'POST',
      data: {
        chat_id: chat_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // チャットボットのログデータと関連するデータ全ての削除
  // #################################################################
  $('.delete_chat_bot_log_data_and_related_data').on('click', function () {
    if (!confirm('本当に完全削除を実行しますか？')) {
      return;
    }
    const chat_id = $('#chat_selects option:selected').val();

    $.ajax({
      url: '/c/delete_chat_log_and_related_data',
      type: 'POST',
      data: {
        chat_id: chat_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.href = '/c/index';
      }
    });
  });

  // #################################################################
  // チャットボットのレポートのcsv出力
  // #################################################################
  $('#download_chat_csv').on('click', function () {
    const chat_id = $('#chat_selects option:selected').val();
    const month = $('#ua_chat_month_selects option:selected').val();
    const device = $('.chat_device_select').data('device');

    let href = '/download_chat_csv';

    href += `?chat_id=${chat_id}`;
    href += `&m=${month}`;
    href += `&device=${device}`;
    location.href = href;
  });

  // ------------------------------------------------------------------------------------------------
  // チャットボット設定
  // ------------------------------------------------------------------------------------------------
  // #################################################################
  // チャットボットの選択と新規登録
  // #################################################################
  $('#chat_bot_select_box').on('change', function () {
    let chat_id = $('#chat_bot_select_box option:selected').val();

    if (chat_id == 'new') {
      $('.chat_bot_set_wrapper').css('display', 'block');
      $('.chat_bot_edit_name_setting_wrapper').css('display', 'none');
      $('.chat_bot_url_setting_wrapper').css('display', 'none');
      $('.chat_bot_excluded_url_setting_wrapper').css('display', 'none');
      $('.chat_bot_delete_setting_wrapper').css('display', 'none');
      $('.chat_bot_detail_custom_setting_wrapper').css('display', 'none');
      $('.chat_bot_pc_design_custom_setting_wrapper').css('display', 'none');
      $('.chat_bot_sp_design_custom_setting_wrapper').css('display', 'none');
      $('.chat_bot_report_jump_btn').css('display', 'none');
      $('.chat_bot_show_valid_setting_wrapper').css('display', 'none');
      $('.chat_bot_preview_setting_wrapper').css('display', 'none');
      $('.chat_bot_preview_url_list_wrapper').css('display', 'none');
      $('.chat_bot_img_upload_wrapper').css('display', 'none');
      $('.chat_bot_icon_upload_wrapper').css('display', 'none');
      $('.chat_bot_img_url_setting_wrapper').css('display', 'none');
      $('.chat_bot_sp_show_valid_setting_wrapper').css('display', 'none');
      $('.chat_bot_title_img_upload_wrapper').css('display', 'none');
    } else {
      location.href = `/chat_bot_setting/index?chat_id=${chat_id}`;
    }
  });


  // #################################################################
  // チャットボットの新規登録
  // #################################################################
  $('#chat_bot_set').on('click', function () {
    let chat_bot_input_val = $('#chat_bot_input').val();
    if (!chat_bot_input_val) {
      alert('チャットボット名を入力してください。');
      return;
    }
    $('#chat_bot_set').css('pointer-events', 'none');
    $.ajax({
      url: DOMAIN + '/create_chat_bot',
      type: 'POST',
      data: {
        name: chat_bot_input_val,
      },
      dataType: 'json',
    }).done(function (data) {
      location.href = `/chat_bot_setting/index?chat_id=${data.chat.id}`;
    });
  });

  // #################################################################
  // チャットボットの名前変更
  // #################################################################
  $('#chat_bot_edit_name_submit').on('click', function () {
    let chat_id = $('#chat_bot_select_box option:selected').val();
    let new_chat_bot_name = $('.chat_bot_edit_name_input').val();
    if (!new_chat_bot_name) {
      alert('チャットボット名を入力してください。');
      return;
    }
    $.ajax({
      url: '/update_chat_bot_name',
      type: 'POST',
      data: {
        chat_id: chat_id,
        name: new_chat_bot_name,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // チャットボットのPC公開設定
  // #################################################################
  $('.chat_bot_show_valid_select_box').on('change', function (event) {
    let chat_id = $('#chat_bot_select_box option:selected').val();
    let show_valid = $('.chat_bot_show_valid_select_box:checked').val();

    $.ajax({
      url: '/save_chat_bot_show_valid',
      type: 'POST',
      data: {
        chat_id: chat_id,
        show_valid: show_valid
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // チャットボットのSP公開設定
  // #################################################################
  $('.chat_bot_sp_show_valid_select_box').on('change', function (event) {
    let chat_id = $('#chat_bot_select_box option:selected').val();
    let show_valid = $('.chat_bot_sp_show_valid_select_box:checked').val();

    $.ajax({
      url: '/save_chat_bot_show_valid_sp',
      type: 'POST',
      data: {
        chat_id: chat_id,
        show_valid: show_valid
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // チャットボットの表示URL登録
  // #################################################################
  $('#chat_bot_url_add_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="chat_bot_url_input w-390px h-30px py-0 px-6 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="chat_bot_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.chat_bot_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });

  $('.chat_bot_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#chat_bot_url_set').on('click', function () {
    let chat_id = $('#chat_bot_select_box option:selected').val();
    let urls = [];
    $('.chat_bot_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/set_chat_bot_url',
      type: 'POST',
      data: {
        chat_id: chat_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // チャットボットの除外URL登録
  // #################################################################
  $('#chat_bot_excluded_url_add_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="chat_bot_excluded_url_input w-390px h-30px py-0 px-6 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="chat_bot_excluded_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.chat_bot_excluded_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });

  $('.chat_bot_excluded_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#chat_bot_excluded_url_set').on('click', function () {
    let chat_id = $('#chat_bot_select_box option:selected').val();
    let urls = [];
    $('.chat_bot_excluded_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/set_chat_bot_excluded_url',
      type: 'POST',
      data: {
        chat_id: chat_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // チャットボットのPCデザイン登録
  // #################################################################
  $('#chat_bot_img_url_set').on('click', function () {
    let chat_id = $('#chat_bot_select_box option:selected').val();

    let chat_bot_img_url = $('#chat_bot_img_url').val();
    let chat_bot_title_img_url = $('#chat_bot_title_img_url').val();
    let chat_bot_icon_url = $('#chat_bot_icon_url').val();

    $.ajax({
      url: '/save_chat_bot_img_url',
      type: 'POST',
      data: {
        chat_id: chat_id,
        img_url: chat_bot_img_url,
        title_img_url: chat_bot_title_img_url,
        icon_url: chat_bot_icon_url
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });

  });

  // #################################################################
  // チャットボットのPCデザイン登録
  // #################################################################
  $('#chat_bot_pc_style_set').on('click', function () {

    let chat_id = $('#chat_bot_select_box option:selected').val();

    let is_content_side_position = $('#is_content_side_position').val();
    let content_side_position = $('#content_side_position').val();
    let content_bottom_position = $('#content_bottom_position').val();

    let is_default_display = $('#is_default_display').val();
    let is_default_icon_side_position = $('#is_default_icon_side_position').val();
    let default_icon_side_position = $('#default_icon_side_position').val();
    let default_icon_bottom_position = $('#default_icon_bottom_position').val();
    let default_icon_img_height = $('#default_icon_img_height').val();
    let default_icon_img_width = $('#default_icon_img_width').val();
    let default_icon_img_border_radius = $('#default_icon_img_border_radius').val();
    let is_default_text_side_position = $('#is_default_text_side_position').val();
    let default_text_side_position = $('#default_text_side_position').val();
    let default_text_bottom_position = $('#default_text_bottom_position').val();
    let default_text_width = $('#default_text_width').val();
    let default_text_border_radius = $('#default_text_border_radius').val();
    let default_text_word = $('#default_text_word').val();
    let default_text_padding = $('#default_text_padding').val();
    let default_text_bg_color = $('#default_text_bg_color').val();
    let default_text_font_color = $('#default_text_font_color').val();
    let default_text_font_size = $('#default_text_font_size').val();
    let default_text_font_weight = $('#default_text_font_weight').val();

    let main_container_bg_color = $('#main_container_bg_color').val();
    let main_container_border_radius = $('#main_container_border_radius').val();
    let main_container_width = $('#main_container_width').val();
    let main_container_height = $('#main_container_height').val();
    let main_container_border = $('#main_container_border').val();
    let main_container_opacity = $('#main_container_opacity').val();
    let main_container_box_shadow = $('#main_container_box_shadow').val();
    let title_area_title_justify_content = $('#title_area_title_justify_content').val();
    let title_area_title_margin = $('#title_area_title_margin').val();
    let title_area_bg = $('#title_area_bg').val();
    let title_area_border_radius = $('#title_area_border_radius').val();
    let title_area_height = $('#title_area_height').val();
    let title_area_img_width = $('#title_area_img_width').val();
    let title_area_img_height = $('#title_area_img_height').val();
    let title_area_img_margin = $('#title_area_img_margin').val();
    let title_area_font_color = $('#title_area_font_color').val();
    let close_btn_width = $('#close_btn_width').val();
    let close_btn_height = $('#close_btn_height').val();
    let close_btn_bg_color = $('#close_btn_bg_color').val();
    let is_header_area = $('#is_header_area').val();
    let header_area_height = $('#header_area_height').val();
    let header_area_padding = $('#header_area_padding').val();
    let header_area_text_one = $('#header_area_text_one').val();
    let header_area_text_two = $('#header_area_text_two').val();
    let header_area_text_padding = $('#header_area_text_padding').val();
    let header_area_text_font_size = $('#header_area_text_font_size').val();
    let comment_area_padding = $('#comment_area_padding').val();
    let comment_area_icon_width = $('#comment_area_icon_width').val();
    let comment_area_icon_height = $('#comment_area_icon_height').val();
    let comment_area_icon_margin = $('#comment_area_icon_margin').val();
    let comment_area_icon_border_radius = $('#comment_area_icon_border_radius').val();
    let comment_box_margin = $('#comment_box_margin').val();
    let comment_box_padding = $('#comment_box_padding').val();
    let comment_box_width = $('#comment_box_width').val();
    let comment_box_border_radius = $('#comment_box_border_radius').val();
    let comment_box_bg_color = $('#comment_box_bg_color').val();
    let comment_text_padding = $('#comment_text_padding').val();
    let comment_text_font_size = $('#comment_text_font_size').val();
    let comment_text_font_weight = $('#comment_text_font_weight').val();
    let comment_text_font_color = $('#comment_text_font_color').val();
    let comment_btn_margin = $('#comment_btn_margin').val();
    let comment_btn_padding = $('#comment_btn_padding').val();
    let comment_btn_border = $('#comment_btn_border').val();
    let comment_btn_border_radius = $('#comment_btn_border_radius').val();
    let comment_btn_white_space = $('#comment_btn_white_space').val();
    let comment_btn_bg_color = $('#comment_btn_bg_color').val();
    let comment_btn_font_color = $('#comment_btn_font_color').val();
    let comment_btn_font_size = $('#comment_btn_font_size').val();
    let comment_btn_box_shadow = $('#comment_btn_box_shadow').val();
    let comment_btn_font_weight = $('#comment_btn_font_weight').val();
    let is_footer_area = $('#is_footer_area').val();
    let loading_container_margin = $('#loading_container_margin').val();
    let loading_container_padding = $('#loading_container_padding').val();
    let loading_box_border_radius = $('#loading_box_border_radius').val();
    let loading_box_bg_color = $('#loading_box_bg_color').val();
    let loading_box_font_color = $('#loading_box_font_color').val();
    let loading_box_font_weight = $('#loading_box_font_weight').val();
    let delete_icon_top = $('#delete_icon_top').val();
    let delete_icon_right = $('#delete_icon_right').val();
    let delete_icon_width = $('#delete_icon_width').val();
    let delete_icon_height = $('#delete_icon_height').val();

    $.ajax({
      url: '/update_chat_bot_pc_styles',
      type: 'POST',
      data: {
        chat_id: chat_id,
        is_content_side_position: is_content_side_position,
        content_side_position: content_side_position,
        content_bottom_position: content_bottom_position,

        is_default_display: is_default_display,
        is_default_icon_side_position: is_default_icon_side_position,
        default_icon_side_position: default_icon_side_position,
        default_icon_bottom_position: default_icon_bottom_position,
        default_icon_img_height: default_icon_img_height,
        default_icon_img_width: default_icon_img_width,
        default_icon_img_border_radius: default_icon_img_border_radius,
        is_default_text_side_position: is_default_text_side_position,
        default_text_side_position: default_text_side_position,
        default_text_bottom_position: default_text_bottom_position,
        default_text_width: default_text_width,
        default_text_border_radius: default_text_border_radius,
        default_text_word: default_text_word,
        default_text_padding: default_text_padding,
        default_text_bg_color: default_text_bg_color,
        default_text_font_color: default_text_font_color,
        default_text_font_size: default_text_font_size,
        default_text_font_weight: default_text_font_weight,

        main_container_bg_color: main_container_bg_color,
        main_container_border_radius: main_container_border_radius,
        main_container_width: main_container_width,
        main_container_height: main_container_height,
        main_container_border: main_container_border,
        main_container_opacity: main_container_opacity,
        main_container_box_shadow: main_container_box_shadow,
        title_area_title_justify_content: title_area_title_justify_content,
        title_area_title_margin: title_area_title_margin,
        title_area_bg: title_area_bg,
        title_area_border_radius: title_area_border_radius,
        title_area_height: title_area_height,
        title_area_img_width: title_area_img_width,
        title_area_img_height: title_area_img_height,
        title_area_img_margin: title_area_img_margin,
        title_area_font_color: title_area_font_color,
        close_btn_width: close_btn_width,
        close_btn_height: close_btn_height,
        close_btn_bg_color: close_btn_bg_color,
        is_header_area: is_header_area,
        header_area_height: header_area_height,
        header_area_padding: header_area_padding,
        header_area_text_one: header_area_text_one,
        header_area_text_two: header_area_text_two,
        header_area_text_padding: header_area_text_padding,
        header_area_text_font_size: header_area_text_font_size,
        comment_area_padding: comment_area_padding,
        comment_area_icon_width: comment_area_icon_width,
        comment_area_icon_height: comment_area_icon_height,
        comment_area_icon_margin: comment_area_icon_margin,
        comment_area_icon_border_radius: comment_area_icon_border_radius,
        comment_box_margin: comment_box_margin,
        comment_box_padding: comment_box_padding,
        comment_box_width: comment_box_width,
        comment_box_border_radius: comment_box_border_radius,
        comment_box_bg_color: comment_box_bg_color,
        comment_text_padding: comment_text_padding,
        comment_text_font_size: comment_text_font_size,
        comment_text_font_weight: comment_text_font_weight,
        comment_text_font_color: comment_text_font_color,
        comment_btn_margin: comment_btn_margin,
        comment_btn_padding: comment_btn_padding,
        comment_btn_border: comment_btn_border,
        comment_btn_border_radius: comment_btn_border_radius,
        comment_btn_white_space: comment_btn_white_space,
        comment_btn_bg_color: comment_btn_bg_color,
        comment_btn_font_color: comment_btn_font_color,
        comment_btn_font_size: comment_btn_font_size,
        comment_btn_box_shadow: comment_btn_box_shadow,
        comment_btn_font_weight: comment_btn_font_weight,
        is_footer_area: is_footer_area,
        loading_container_margin: loading_container_margin,
        loading_container_padding: loading_container_padding,
        loading_box_border_radius: loading_box_border_radius,
        loading_box_bg_color: loading_box_bg_color,
        loading_box_font_color: loading_box_font_color,
        loading_box_font_weight: loading_box_font_weight,
        delete_icon_top: delete_icon_top,
        delete_icon_right: delete_icon_right,
        delete_icon_width: delete_icon_width,
        delete_icon_height: delete_icon_height
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // チャットボットのSPデザイン登録
  // #################################################################
  $('#chat_bot_sp_style_set').on('click', function () {

    let chat_id = $('#chat_bot_select_box option:selected').val();

    let is_content_side_position_sp = $('#is_content_side_position_sp').val();
    let content_side_position_sp = $('#content_side_position_sp').val();
    let content_bottom_position_sp = $('#content_bottom_position_sp').val();
    
    let is_default_display_sp = $('#is_default_display_sp').val();
    let is_default_icon_side_position_sp = $('#is_default_icon_side_position_sp').val();
    let default_icon_side_position_sp = $('#default_icon_side_position_sp').val();
    let default_icon_bottom_position_sp = $('#default_icon_bottom_position_sp').val();
    let default_icon_img_height_sp = $('#default_icon_img_height_sp').val();
    let default_icon_img_width_sp = $('#default_icon_img_width_sp').val();
    let default_icon_img_border_radius_sp = $('#default_icon_img_border_radius_sp').val();
    let is_default_text_side_position_sp = $('#is_default_text_side_position_sp').val();
    let default_text_side_position_sp = $('#default_text_side_position_sp').val();
    let default_text_bottom_position_sp = $('#default_text_bottom_position_sp').val();
    let default_text_width_sp = $('#default_text_width_sp').val();
    let default_text_border_radius_sp = $('#default_text_border_radius_sp').val();
    let default_text_word_sp = $('#default_text_word_sp').val();
    let default_text_padding_sp = $('#default_text_padding_sp').val();
    let default_text_bg_color_sp = $('#default_text_bg_color_sp').val();
    let default_text_font_color_sp = $('#default_text_font_color_sp').val();
    let default_text_font_size_sp = $('#default_text_font_size_sp').val();
    let default_text_font_weight_sp = $('#default_text_font_weight_sp').val();

    let main_container_bg_color_sp = $('#main_container_bg_color_sp').val();
    let main_container_border_radius_sp = $('#main_container_border_radius_sp').val();
    let main_container_width_sp = $('#main_container_width_sp').val();
    let main_container_height_sp = $('#main_container_height_sp').val();
    let main_container_border_sp = $('#main_container_border_sp').val();
    let main_container_opacity_sp = $('#main_container_opacity_sp').val();
    let main_container_box_shadow_sp = $('#main_container_box_shadow_sp').val();
    let title_area_title_justify_content_sp = $('#title_area_title_justify_content_sp').val();
    let title_area_title_margin_sp = $('#title_area_title_margin_sp').val();
    let title_area_bg_sp = $('#title_area_bg_sp').val();
    let title_area_border_radius_sp = $('#title_area_border_radius_sp').val();
    let title_area_height_sp = $('#title_area_height_sp').val();
    let title_area_img_width_sp = $('#title_area_img_width_sp').val();
    let title_area_img_height_sp = $('#title_area_img_height_sp').val();
    let title_area_img_margin_sp = $('#title_area_img_margin_sp').val();
    let title_area_font_color_sp = $('#title_area_font_color_sp').val();
    let close_btn_width_sp = $('#close_btn_width_sp').val();
    let close_btn_height_sp = $('#close_btn_height_sp').val();
    let close_btn_bg_color_sp = $('#close_btn_bg_color_sp').val();
    let is_header_area_sp = $('#is_header_area_sp').val();
    let header_area_height_sp = $('#header_area_height_sp').val();
    let header_area_padding_sp = $('#header_area_padding_sp').val();
    let header_area_text_one_sp = $('#header_area_text_one_sp').val();
    let header_area_text_two_sp = $('#header_area_text_two_sp').val();
    let header_area_text_padding_sp = $('#header_area_text_padding_sp').val();
    let header_area_text_font_size_sp = $('#header_area_text_font_size_sp').val();
    let comment_area_padding_sp = $('#comment_area_padding_sp').val();
    let comment_area_icon_width_sp = $('#comment_area_icon_width_sp').val();
    let comment_area_icon_height_sp = $('#comment_area_icon_height_sp').val();
    let comment_area_icon_margin_sp = $('#comment_area_icon_margin_sp').val();
    let comment_area_icon_border_radius_sp = $('#comment_area_icon_border_radius_sp').val();
    let comment_box_margin_sp = $('#comment_box_margin_sp').val();
    let comment_box_padding_sp = $('#comment_box_padding_sp').val();
    let comment_box_width_sp = $('#comment_box_width_sp').val();
    let comment_box_border_radius_sp = $('#comment_box_border_radius_sp').val();
    let comment_box_bg_color_sp = $('#comment_box_bg_color_sp').val();
    let comment_text_padding_sp = $('#comment_text_padding_sp').val();
    let comment_text_font_size_sp = $('#comment_text_font_size_sp').val();
    let comment_text_font_weight_sp = $('#comment_text_font_weight_sp').val();
    let comment_text_font_color_sp = $('#comment_text_font_color_sp').val();
    let comment_btn_margin_sp = $('#comment_btn_margin_sp').val();
    let comment_btn_padding_sp = $('#comment_btn_padding_sp').val();
    let comment_btn_border_sp = $('#comment_btn_border_sp').val();
    let comment_btn_border_radius_sp = $('#comment_btn_border_radius_sp').val();
    let comment_btn_white_space_sp = $('#comment_btn_white_space_sp').val();
    let comment_btn_bg_color_sp = $('#comment_btn_bg_color_sp').val();
    let comment_btn_font_color_sp = $('#comment_btn_font_color_sp').val();
    let comment_btn_font_size_sp = $('#comment_btn_font_size_sp').val();
    let comment_btn_box_shadow_sp = $('#comment_btn_box_shadow_sp').val();
    let comment_btn_font_weight_sp = $('#comment_btn_font_weight_sp').val();
    let is_footer_area_sp = $('#is_footer_area_sp').val();
    let loading_container_margin_sp = $('#loading_container_margin_sp').val();
    let loading_container_padding_sp = $('#loading_container_padding_sp').val();
    let loading_box_border_radius_sp = $('#loading_box_border_radius_sp').val();
    let loading_box_bg_color_sp = $('#loading_box_bg_color_sp').val();
    let loading_box_font_color_sp = $('#loading_box_font_color_sp').val();
    let loading_box_font_weight_sp = $('#loading_box_font_weight_sp').val();
    let delete_icon_top_sp = $('#delete_icon_top_sp').val();
    let delete_icon_right_sp = $('#delete_icon_right_sp').val();
    let delete_icon_width_sp = $('#delete_icon_width_sp').val();
    let delete_icon_height_sp = $('#delete_icon_height_sp').val();

    $.ajax({
      url: '/update_chat_bot_sp_styles',
      type: 'POST',
      data: {
        chat_id: chat_id,
        is_content_side_position_sp: is_content_side_position_sp,
        content_side_position_sp: content_side_position_sp,
        content_bottom_position_sp: content_bottom_position_sp,
        default_icon_img_width_sp: default_icon_img_width_sp,
        default_icon_img_height_sp: default_icon_img_height_sp,
        default_icon_img_border_radius_sp: default_icon_img_border_radius_sp,

        is_default_display_sp: is_default_display_sp,
        is_default_icon_side_position_sp: is_default_icon_side_position_sp,
        default_icon_side_position_sp: default_icon_side_position_sp,
        default_icon_bottom_position_sp: default_icon_bottom_position_sp,
        default_icon_img_height_sp: default_icon_img_height_sp,
        default_icon_img_width_sp: default_icon_img_width_sp,
        default_icon_img_border_radius_sp: default_icon_img_border_radius_sp,
        is_default_text_side_position_sp: is_default_text_side_position_sp,
        default_text_side_position_sp: default_text_side_position_sp,
        default_text_bottom_position_sp: default_text_bottom_position_sp,
        default_text_width_sp: default_text_width_sp,
        default_text_border_radius_sp: default_text_border_radius_sp,
        default_text_word_sp: default_text_word_sp,
        default_text_padding_sp: default_text_padding_sp,
        default_text_bg_color_sp: default_text_bg_color_sp,
        default_text_font_color_sp: default_text_font_color_sp,
        default_text_font_size_sp: default_text_font_size_sp,
        default_text_font_weight_sp: default_text_font_weight_sp,

        main_container_bg_color_sp: main_container_bg_color_sp,
        main_container_border_radius_sp: main_container_border_radius_sp,
        main_container_width_sp: main_container_width_sp,
        main_container_height_sp: main_container_height_sp,
        main_container_border_sp: main_container_border_sp,
        main_container_opacity_sp: main_container_opacity_sp,
        main_container_box_shadow_sp: main_container_box_shadow_sp,
        title_area_title_justify_content_sp: title_area_title_justify_content_sp,
        title_area_title_margin_sp: title_area_title_margin_sp,
        title_area_bg_sp: title_area_bg_sp,
        title_area_border_radius_sp: title_area_border_radius_sp,
        title_area_height_sp: title_area_height_sp,
        title_area_img_width_sp: title_area_img_width_sp,
        title_area_img_height_sp: title_area_img_height_sp,
        title_area_img_margin_sp: title_area_img_margin_sp,
        title_area_font_color_sp: title_area_font_color_sp,
        close_btn_width_sp: close_btn_width_sp,
        close_btn_height_sp: close_btn_height_sp,
        close_btn_bg_color_sp: close_btn_bg_color_sp,
        is_header_area_sp: is_header_area_sp,
        header_area_height_sp: header_area_height_sp,
        header_area_padding_sp: header_area_padding_sp,
        header_area_text_one_sp: header_area_text_one_sp,
        header_area_text_two_sp: header_area_text_two_sp,
        header_area_text_padding_sp: header_area_text_padding_sp,
        header_area_text_font_size_sp: header_area_text_font_size_sp,
        comment_area_padding_sp: comment_area_padding_sp,
        comment_area_icon_width_sp: comment_area_icon_width_sp,
        comment_area_icon_height_sp: comment_area_icon_height_sp,
        comment_area_icon_margin_sp: comment_area_icon_margin_sp,
        comment_area_icon_border_radius_sp: comment_area_icon_border_radius_sp,
        comment_box_margin_sp: comment_box_margin_sp,
        comment_box_padding_sp: comment_box_padding_sp,
        comment_box_width_sp: comment_box_width_sp,
        comment_box_border_radius_sp: comment_box_border_radius_sp,
        comment_box_bg_color_sp: comment_box_bg_color_sp,
        comment_text_padding_sp: comment_text_padding_sp,
        comment_text_font_size_sp: comment_text_font_size_sp,
        comment_text_font_weight_sp: comment_text_font_weight_sp,
        comment_text_font_color_sp: comment_text_font_color_sp,
        comment_btn_margin_sp: comment_btn_margin_sp,
        comment_btn_padding_sp: comment_btn_padding_sp,
        comment_btn_border_sp: comment_btn_border_sp,
        comment_btn_border_radius_sp: comment_btn_border_radius_sp,
        comment_btn_white_space_sp: comment_btn_white_space_sp,
        comment_btn_bg_color_sp: comment_btn_bg_color_sp,
        comment_btn_font_color_sp: comment_btn_font_color_sp,
        comment_btn_font_size_sp: comment_btn_font_size_sp,
        comment_btn_box_shadow_sp: comment_btn_box_shadow_sp,
        comment_btn_font_weight_sp: comment_btn_font_weight_sp,
        is_footer_area_sp: is_footer_area_sp,
        loading_container_margin_sp: loading_container_margin_sp,
        loading_container_padding_sp: loading_container_padding_sp,
        loading_box_border_radius_sp: loading_box_border_radius_sp,
        loading_box_bg_color_sp: loading_box_bg_color_sp,
        loading_box_font_color_sp: loading_box_font_color_sp,
        loading_box_font_weight_sp: loading_box_font_weight_sp,
        delete_icon_top_sp: delete_icon_top_sp,
        delete_icon_right_sp: delete_icon_right_sp,
        delete_icon_width_sp: delete_icon_width_sp,
        delete_icon_height_sp: delete_icon_height_sp
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // チャットボットのプレビュー作成
  // #################################################################
  $('#chat_bot_create_preview_btn')
    .off()
    .on('click', function () {
      $('.loadding').css('display', 'block');
      let chat_bot_id = $('#chat_bot_select_box option:selected').val();
      let preview_url = $('#chat_bot_create_preview_url').val();
      if (chat_bot_id == '' || chat_bot_id == null || preview_url == '') {
        $('.loadding').css('display', 'none');
        alert('必須項目を入力してください。');
        return;
      }

      $.ajax({
        url: '/chat_bot_setting/save_chat_bot_preview',
        type: 'POST',
        data: {
          chat_bot_id: chat_bot_id,
          url: preview_url
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '0') {
          location.reload();
        }
      });
    });

  // #################################################################
  // チャットボットのプレビュー編集
  // #################################################################
  $('.create_chat_bot_preview_html_edit').on('click', function () {
    let preview_id = $(this).data('id');
    let preview_url = $(this).data('url');
    $.ajax({
      url: '/edit_chat_bot_preview_html',
      type: 'POST',
      data: {
        id: preview_id,
        url: preview_url,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        // モーダルを作成し、HTMLコンテンツとボタンを表示
        let modalHtml = `<div id="html_modal_wrapper"></div>
                        <div id="html_modal_container" class="fixed p-5 top-[2.5%] left-1/2 transform -translate-x-1/2 w-90per h-90per overflow-auto text-center bg-white dark:text-gray-500 dark:bg-gray-900 dark:border-b dark:border-black">
                          <div class="border border-gray-200 h-90per mb-4">
                            <textarea id="html_modal_text_area" class="p-2 h-full w-full"></textarea>
                          </div>
                          <div class="flex justify-center">
                            <div id="html_remove_btn" class="btn text-14px w-250px p-3 cursor-pointer text-center text-white rounded-md bg-gray-500 hover:bg-gray-700 dark:hover:bg-gray-600 dark:bg-gray-800 dark:text-gray-500">閉じる</div>
                            <div id="html_save_btn" class="btn text-14px w-250px p-3 cursor-pointer text-center text-white rounded-md bg-base-800 hover:bg-base-800 ml-2 dark:bg-dark_base dark:hover:bg-dark_base-hover dark:text-gray-500">保存</div>
                          </div>
                        </div>`;

        // モーダルをbody要素に追加
        $('body').append(modalHtml);
        $('#html_modal_text_area').text(data.html_content);

        $('#html_save_btn').on('click', function () {
          let html = $('#html_modal_text_area').val();
          $.ajax({
            url: '/update_chat_bot_preview_html',
            type: 'POST',
            data: {
              id: preview_id,
              url: preview_url,
              html: html,
            },
            dataType: 'json',
          }).done(function (data) {
            if (data.ret == '0') {
              location.reload();
            }
          });
        });

        $('#html_modal_wrapper, #html_remove_btn').on('click', function (e) {
          $('#html_modal_wrapper, #html_modal_container, #html_modal_text_area, #html_save_btn').remove();
        });
      }
    });
  });

  // #################################################################
  // チャットボットのプレビュー削除
  // #################################################################
  $('.create_chat_bot_preview_url_delete').on('click', function () {
    let preview_id = $(this).data('id');
    let preview_url = $(this).data('url');
    $.ajax({
      url: '/delete_chat_bot_preview',
      type: 'POST',
      data: {
        id: preview_id,
        url: preview_url,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // バナー登録
  // #################################################################
  $('#chat_bot_img_upload_btn').on('click', function() {
    let chat_id = $(this).data("chat_id");
    let file_data = $('.chat_bot_img_upload').prop('files')[0];
    if (!file_data) {
      alert('画像を選択してください。');
      return;
    }
    var form_data = new FormData();
    form_data.append('chat_bot_img_upload', file_data);
    form_data.append('chat_id', chat_id);  // chat_idをFormDataに追加

    $.ajax({
      url: '/upload_chat_bot_img',
      type: 'POST',
      data: form_data,
      processData: false,
      contentType: false,
      success: function(response) {
        location.reload();
      },
      error: function(response) {
        alert('画像のアップロードに失敗しました。');
        location.reload();
      }
    });
  });

  // #################################################################
  // バナー画像削除
  // #################################################################
  $('#chat_bot_img_delete_btn').on('click', function() {
    let chat_id = $(this).data("chat_id");

    $.ajax({
      url: '/delete_chat_bot_img',
      type: 'POST',
      data: {
        chat_id: chat_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // チャットボットのヘッダーアイコン登録
  // #################################################################
  $('#chat_bot_title_img_upload_btn').on('click', function() {
    let chat_id = $(this).data("chat_id");
    let file_data = $('.chat_bot_title_img_upload').prop('files')[0];
    if (!file_data) {
      alert('画像を選択してください。');
      return;
    }
    var form_data = new FormData();
    form_data.append('chat_bot_title_img_upload', file_data);
    form_data.append('chat_id', chat_id);  // chat_idをFormDataに追加

    $.ajax({
      url: '/upload_chat_bot_title_img',
      type: 'POST',
      data: form_data,
      processData: false,
      contentType: false,
      success: function(response) {
        location.reload();
      },
      error: function(response) {
        alert('画像のアップロードに失敗しました。');
        location.reload();
      }
    });
  });

  // #################################################################
  // アイコン登録
  // #################################################################
  $('#chat_bot_icon_upload_btn').on('click', function() {
    let chat_id = $(this).data("chat_id");
    let file_data = $('.chat_bot_icon_upload').prop('files')[0];
    if (!file_data) {
      alert('画像を選択してください。');
      return;
    }
    var form_data = new FormData();
    form_data.append('chat_bot_icon_upload', file_data);
    form_data.append('chat_id', chat_id);  // chat_idをFormDataに追加

    $.ajax({
      url: '/upload_chat_bot_icon',
      type: 'POST',
      data: form_data,
      processData: false,
      contentType: false,
      success: function(response) {
        location.reload();
      },
      error: function(response) {
        alert('画像のアップロードに失敗しました。');
        location.reload();
      }
    });
  });

  // #################################################################
  // アイコン画像削除
  // #################################################################
  $('#chat_bot_icon_delete_btn').on('click', function() {
    let chat_id = $(this).data("chat_id");

    $.ajax({
      url: '/delete_chat_bot_icon',
      type: 'POST',
      data: {
        chat_id: chat_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // チャットボット削除
  // #################################################################
  $('#chat_bot_delete_btn').on('click', function () {
    let chat_id = $('#chat_bot_select_box option:selected').val();

    if (!confirm('完全に削除され復元することはできません。本当に削除しますか？')) {
      return;
    }

    $.ajax({
      url: '/chat_bot_setting/delete_chat_bot_setting',
      type: 'POST',
      data: {
        chat_id: chat_id,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('チャットボットを削除しました。');
      location.href = `/chat_bot_setting/index`;
    });
  });
});
